import React from 'react';
import { Link } from 'react-router-dom';
import styled, {  withTheme } from 'styled-components';
import Intl from '../common/Intl'
import { withAppContext } from 'src/store/initAppContext';

type Props = {}

const FooterSeoLinks = (props: any) => {

    const { app: { brandId }, theme } = props
    const { config: { customercare } } = theme;
    return (
        <>
            <FooterSeoLink>
                <div className='seoLinkBlock'>
                    <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@CASINO" /></div>
                    <ul>
                        <li><Link to="/live-casino"><Intl langKey="FooterSeoLinks@LIVECASINO" /></Link></li>
                        <li><Link to="/slots"><Intl langKey="FooterSeoLinks@SLOT" /></Link></li>
                        <li><Link to="/instant-games"><Intl langKey="FooterSeoLinks@INSTANTGAMES" /></Link></li>
                        <li><Link to="/popular-games"><Intl langKey="FooterSeoLinks@POPULARGAMES" /></Link></li>
                        <li><Link to="/live-casino/live-roulette"><Intl langKey="FooterSeoLinks@LIVEROULETTE" /></Link></li>
                        <li><Link to="/live-casino/dragon-tiger"><Intl langKey="FooterSeoLinks@DRAGONTIGER" /></Link></li>
                        <li><Link to="/live-casino/live-baccarat"><Intl langKey="FooterSeoLinks@LIVEBACCARAT" /></Link></li>
                        <li><Link to="/live-casino/live-blackjack"><Intl langKey="FooterSeoLinks@LIVEBLACKJACK" /></Link></li>
                        <li><Link to="/live-casino/teenpatti"><Intl langKey="FooterSeoLinks@TEENPATTI" /></Link></li>
                        <li><Link to="/promotions/welcome-bonus"><Intl langKey="FooterSeoLinks@WELCOMEBONUS" /></Link></li>
                    </ul>
                </div>
                <div className='seoLinkBlock'>
                    <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@SPORTS" /></div>
                    <ul>
                        <li><Link to="/betting-exchange"><Intl langKey="FooterSeoLinks@BETTINGEXCHANGE" /></Link></li>
                        <li><Link to="/sportsbook"><Intl langKey="FooterSeoLinks@SPORTSBOOK" /></Link></li>
                        <li><Link to="/premium-sportsbook"><Intl langKey="FooterSeoLinks@PREMIUMSPORTSBOOK" /></Link></li>
                        <li><Link to="/saba-sports"><Intl langKey="FooterSeoLinks@SABA" /></Link></li>
                        <li><Link to="/betting-exchange/online-cricket-betting"><Intl langKey="FooterSeoLinks@CRICKETBETTING" /></Link></li>
                        <li><Link to="/betting-exchange/football-betting"><Intl langKey="FooterSeoLinks@FOOTBALLBETTING" /></Link></li>
                        <li><Link to="/betting-exchange/tennis-betting"><Intl langKey="FooterSeoLinks@TENNISBETTING" /></Link></li>
                        <li><Link to="/virtualSports/vci"><Intl langKey="FooterSeoLinks@VIRTUALSPORTS" /></Link></li>
                    </ul>
                </div>
                <div className='seoLinkBlock'>
                    <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@CRASHGAMES" /></div>
                    <ul>
                        <li><Link to="/instant-games/spribe/aviator"><Intl langKey="FooterSeoLinks@AVIATORCRASH" /></Link></li>
                        <li><Link to="/instant-games/aviatrix"><Intl langKey="FooterSeoLinks@AVIATRIXCRASH" /></Link></li>
                        <li><Link to="/instant-games/smartsoft/jetx"><Intl langKey="FooterSeoLinks@JETXCRASH" /></Link></li>
                        <li><Link to="/instant-games/turbo-games/aero"><Intl langKey="FooterSeoLinks@AEROCRASH" /></Link></li>
                        <li><Link to="/instant-games/galaxsys/ninja-crash"><Intl langKey="FooterSeoLinks@NINJACRASH" /></Link></li>
                    </ul>
                </div>
                <div className='seoLinkBlock'>
                    <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@HELP" /></div>
                    <ul>
                        <li><a href={`${customercare}`}><Intl langKey="FooterSeoLinks@YOLO247SUPPORT" /></a></li>
                        <li><a href={`${customercare}`}><Intl langKey="FooterSeoLinks@CUSTOMERCARE" /></a></li>
                        <li><Link to="/faq"><Intl langKey="FooterSeoLinks@FAQ" /></Link></li>
                        <li><Link to="/responsible-gambling"><Intl langKey="FooterSeoLinks@RESPONSIBLEGAMBLING" /></Link></li>
                        <li><a href="https://www.yolo247.site/blog/"><Intl langKey="FooterSeoLinks@BLOG" /></a></li>
                        <li><a href="https://www.yolo247.site/blog/online-crypto-casino"><Intl langKey="FooterSeoLinks@CRYPTOCASINOGUIDE" /></a></li>
                        {/* <li><Link to="/sitemap/"><Intl langKey="FooterSeoLinks@SITEMAP" /></Link></li> */}
                    </ul>
                </div>
                <div className='seoLinkBlock'>
                    <div className='seoLinkBlockTittle'><Intl langKey="FooterSeoLinks@ABOUTUS" /></div>
                    <ul>
                        <li><Link to="/about-us"><Intl langKey="FooterSeoLinks@ABOUTYOLO247" /></Link></li>
                        <li><Link to="/terms-conditions"><Intl langKey="FooterSeoLinks@TERMSCONDITIONS" /></Link></li>
                        <li><Link to="/privacy-policy"><Intl langKey="FooterSeoLinks@PRIVACYPOLICY" /></Link></li>
                        <li><Link to="/kyc-policy"><Intl langKey="FooterSeoLinks@KYCPOLICY" /></Link></li>
                        <li><Link to="/exclusion-policy"><Intl langKey="FooterSeoLinks@SELFEXCLUSIONPOLICY" /></Link></li>
                        <li><Link to="/aml-policy"><Intl langKey="FooterSeoLinks@AMLPOLICY" /></Link></li>
                        <li><Link to="/sponsors"><Intl langKey="FooterSeoLinks@SPONSORSHIPS" /></Link></li>
                        <li><Link to="/affiliate"><Intl langKey="FooterSeoLinks@AFFILIATE" /></Link></li>
                        <li><a href="https://www.yolo247.site/press/"><Intl langKey="FooterSeoLinks@PRESS" /></a></li>
                    </ul>
                </div>
            </FooterSeoLink>
        </>
    )
}

export default withTheme(withAppContext(FooterSeoLinks))

// Styled Components
const FooterSeoLink = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 7rem;
    padding: 2rem 3rem;
    background: #0E0E0E;
    margin-bottom: 2rem;

    .seoLinkBlock {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        color: #e1e5e8;
        text-align: left;
        /* width: 25%; */

        ul {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            margin: 0;
            padding: 0;
            list-style: none;

            li {
                font-size: 13px;

                a {
                    width: auto;
                    padding: 0;
                    border-radius: 0;
                    color: #fff;
                    justify-content: flex-start;

                    :hover {
                        color: #6778e3;
                        background-color: transparent;
                    }
                }
            }
        }
    }

    .seoLinkBlockTittle {
        color: #6778E3;
        text-transform: capitalize;
        font-weight: 700;
        font-size: 16px;
        text-align: left;
    }
`;